import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '../interfaces/IError';
import { getPreference, putPreference } from '@/appLogic/preferenceManage';
import { getOrganizationId } from '@/utils/token';
import { objectFromTupleAndValue } from '@/utils/createObject';
import { InputFileType, inputFileTypes, RegisterExcelInfo } from '@/coreDomainsModule/entities/inputExcelInfo';
import { IYearMonthRangeInfosRepository } from '../interfaces/IYearMonthRangeInfosRepository';
import { TableType, tableType } from '@/coreDomainsModule/table';
import { YearMonthRange } from '@/coreDomainsModule/entities/yearMonthRange';
import { start } from 'repl';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { table } from 'console';
import { simpleCopy } from '@/utils/deepCopy';

/**
 * 年月選択範囲情報を管理する
 */
export class YearMonthRangeInfoRepository implements IYearMonthRangeInfosRepository {
  private myPreferences;

  /**
   * 年月選択範囲情報をまとめて取得する
   */
  async get(): Promise<Record<TableType, YearMonthRange> | undefined> {
    const yearMonthRangeInfos = await getPreference(await getOrganizationId(), 'yearMonthRangeInfos');
    return yearMonthRangeInfos ? yearMonthRangeInfos : undefined;
  }

  /**
   * 年月選択範囲情報を登録する
   * @param tableTypeInfo - テーブルの種類
   * @param data - データ
   */
  async put(tableTypeInfo: TableType, data: YearMonthRange): Promise<void> {
    let myPreferences;
    const yearMonthRangeInfos = await getPreference(await getOrganizationId(), 'yearMonthRangeInfos'); // NOTE: 一旦情報を取得する

    // もし登録されてなければ初期化する
    if (yearMonthRangeInfos != null) {
      myPreferences = yearMonthRangeInfos;
    } else {
      myPreferences = tableType.reduce((acc, type) => {
        acc[type] = undefined; // 各テーブルタイプに対して初期化
        return acc;
      }, {} as Record<TableType, undefined>);
    }

    // 登録情報の更新
    myPreferences[tableTypeInfo] = simpleCopy(data);

    await putPreference(await getOrganizationId(), 'yearMonthRangeInfos', myPreferences);
  }
}
